import AuthService from '../../services/AuthService';
import ApiClient from '../../services/ApiClient';
import {fetchCurrentUserApplications} from "@/services/UserService";
import {decode} from "@/services/JwtService";
import Cookies from "js-cookie";
import {getNewToken} from "@/services/AuthService";
import i18n from "@/i18n";
import {localize} from "vee-validate";
import {loadGrants} from "@dealer-group/dealerui";

let tokenStorageKey = 'id_token';

export const initialState = () => ({
    isLoading: false,
    error: null,
    isAuthenticated: false,
    token: false,
    storedTokenChecked: false,
    applications: []
});

export const namespaced = true;
export const state = initialState();

export const getters = {
    hasError(state) {
        return state.error !== null;
    },

    hasAccessToContextApp(state, getters, rootState) {

        if (state.applications.length === 0) {
            return false;
        }

        return !! state.applications.find(el => el.domain === rootState.context.app.domain);
    },

    user(state, getters, rootState, rootGetters) {

        if (! state.isAuthenticated) {
            return;
        }

        let tokenPayload = decode(state.token);
        return rootGetters['User/findUser'](tokenPayload.uuid);
    },

    tokenPayload(state) {
        if (! state.token) {
            return null;
        }

        return decode(state.token);
    },
};



export const mutations = {

    /**
     * Ustawia stan próby autoryzacji
     * @param state
     */
    AUTHENTICATING(state) {
        state.isLoading = true;
        state.error = null;
        state.isAuthenticated = false;
    },

    /**
     * Ustawia stan po udanej autoryzacji
     * @param state
     * @param data
     */
    AUTHENTICATING_SUCCESS(state, data) {
        state.isLoading = false;
        state.error = null;
        state.isAuthenticated = true;

        // Zapis tokenu JWT
        state.token = data.token;
    },

    STORED_TOKEN_CHECKED(state) {
        state.storedTokenChecked = true;
    },

    /**
     * Ustawia stan błędu po nieudanej próbie autoryzacji
     * @param state
     * @param error
     */
    AUTHENTICATING_ERROR(state, error) {
        state.isLoading = false;
        state.error = error;
        state.isAuthenticated = false;
        state.token = false;
    },

    /**
     * Ustawia stan wylogowania
     * @param state
     */
    LOGOUT(state) {
        state.isLoading = false;
        state.error = null;
        state.isAuthenticated = false;
        state.token = null;
        Cookies.remove(tokenStorageKey, {path: '/'});
    },


    APPLICATIONS_FETCHED(state, data) {
        state.applications = data;
    },

    RESET_STATE(state) {
        Object.assign(state, initialState());
    }
};

export const actions = {

    /**
     * Podejmowanie próby zalogowania się do aplikacji
     *
     * @param commit
     * @param dispatch
     * @param payload
     */
    async login({commit, dispatch}, payload) {
        commit('AUTHENTICATING');

        try {
            return await AuthService.login(payload.email, payload.password)
                .then(async ({data}) => {
                    await dispatch('onValidTokenReceived', data.token);
                    commit('STORED_TOKEN_CHECKED');
                })
        } catch (err) {
            commit('AUTHENTICATING_ERROR', err)
        }

    },

    async loginByCode({commit, dispatch}, code) {
        commit('AUTHENTICATING');

        try {
            return AuthService.loginByCode(code)
                .then(async ({data}) => {
                    await dispatch('onValidTokenReceived', data.access_token);
                    commit('STORED_TOKEN_CHECKED');
                })
        } catch (err) {
            commit('AUTHENTICATING_ERROR', err)
        }
    },

    fetchApplications({commit}) {

        return fetchCurrentUserApplications()
            .then(({data}) => {
                commit('APPLICATIONS_FETCHED', data.data)
            });
    },

    /**
     * Uruchamia weryfikację tokenu
     *
     * @param commit
     * @returns {Q.Promise<any>}
     */
    checkStoredToken({commit, dispatch}) {

        let token = Cookies.get(tokenStorageKey, {path: '/'});

        if (token) {
            return  getNewToken(token)
                .then(async ({data}) => {
                    await dispatch('onValidTokenReceived', data.data.token);
                    commit('STORED_TOKEN_CHECKED');
                })
                .catch(() => {
                    Cookies.remove(tokenStorageKey, {path: '/'});
                    commit('STORED_TOKEN_CHECKED');
                });
        }

        commit('STORED_TOKEN_CHECKED');
    },

    async onValidTokenReceived({commit, dispatch}, token) {
        Cookies.set(tokenStorageKey, token, {path: '/', secure: location.protocol === 'https:', sameSite: location.protocol === 'https:' ? 'None' : null});
        ApiClient.defaults.headers.common = {'Authorization': "Bearer " + token};
        await loadGrants();
        commit('AUTHENTICATING_SUCCESS', {token});
        let tokenPayload = decode(state.token);
        let language = tokenPayload.language;
        if (language) {
            localStorage.setItem('language', language);
            i18n.locale = tokenPayload.language;
            localize(i18n.locale);
        }
        await dispatch('User/fetchUser', {uuid: tokenPayload.uuid}, {root: true})
    },

    reloadToken({commit, dispatch}) {
        return getNewToken()
            .then(({data}) => {
                dispatch('onValidTokenReceived', data.data.token);
                commit('STORED_TOKEN_CHECKED');
            })
            .catch((err) => {
                commit('AUTHENTICATING_ERROR', err)
            });
    },

    /**
     * Wylogowywanie się z aplikacji
     * @param commit
     */
    logout({commit}) {
        commit('LOGOUT');
    },

    resetState({commit}) {
        commit('RESET_STATE');
    }
};

